
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import {
    EnumModel,
    JobItemType,
    JobItemTypeEnums,
    JobItemTypeEnumsGeneric,
    EnumModelGeneric
  } from '@/common/enumerations';
  import * as StringUtils from '@/utilities/string.utils';
  import { Client, ServiceTypeModel, ServiceTypeCreateModel } from '@/services/api.service';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import { EventBus } from '@/event-bus';
  import { ServiceTypeCreatedMessage } from '@/services/eventbus.models';

  @Component({
    filters: {
      toJobItemType: toJobItemTypeFormatter
    }
  })
  export default class ServiceTypeCreate extends Vue {
    private name: string = '';
    private description: string = '';
    private baseRate: number = 0;
    private isUnitRate: boolean = false;

    private availableJobItemTypes: EnumModel[] = [];
    private selectedJobItemType: number = 0;

    public formIsValid: boolean | null = null;
    public isServiceProcessing: boolean = false;

    @Validations()
    private validations = {
      name: { required }
    };

    private mounted() {
      this.availableJobItemTypes.push(
        ...JobItemTypeEnumsGeneric.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''))
      );
      const anyJobItemTypeModel: EnumModel = new EnumModel('(Any Job Type)', 0);
      this.availableJobItemTypes.unshift(anyJobItemTypeModel);
      this.selectedJobItemType = anyJobItemTypeModel.value;
    }

    private createServiceType() {
      // Do the work here
      // Run the validation
      this.isServiceProcessing = true;
      // @ts-ignore
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
        this.isServiceProcessing = false;
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const newServiceType: ServiceTypeCreateModel = new ServiceTypeCreateModel();

        newServiceType.init({
          name: this.name,
          description: this.description,
          parentJobType: this.selectedJobItemType,
          baseRate: this.baseRate,
          isUnitRate: this.isUnitRate,
          isDeleted: false
        });
        console.log(newServiceType);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService.createServiceType(newServiceType).then((data: ServiceTypeModel) => {
          // Route to the edit job list screen?
          console.log('Returned service type:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Service Type ' + me.name + ' created successfully');
          me.$emit('servicetype-created', data);
          EventBus.$emit('servicetype-created', new ServiceTypeCreatedMessage(data));
          me.closeModal();
        });
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-servicetype-create');
    }
  }
